module.exports = __webpack_public_path__ + "static/img/011.3a3749b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/011.jpg
// module id = 92m8
// module chunks = 0